import { Box, Divider, Grid, Stack, Typography } from "@mui/material"
import { FormCard } from "../../../../../../../shared/components/forms/FormCard"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import TerminalImage from "../../assets/P400.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircle } from "@fortawesome/pro-regular-svg-icons"
import { faChevronLeft, faXmark } from "@fortawesome/pro-solid-svg-icons"
import React from "react"
import { makeStyles } from "tss-react/mui"
import { tailwindPalette } from "../../../../../../theme/tailwindPalette"

const useStyles = makeStyles()(() => ({
    terminalImage: {
        maxWidth: "100%",
        borderRadius: "1rem",
        maxHeight: "25rem",
    },
    keyRow: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        marginBottom: "8px",
    },
    keyIcon: {
        fontSize: "1.25rem",
    },
    smallKeyIcon: {
        marginLeft: ".5rem",
        fontSize: "1rem",
    },
    cancelKey: {
        color: tailwindPalette.red[500],
    },
    clearKey: {
        color: tailwindPalette.amber[200],
    },
    confirmKey: {
        color: tailwindPalette.green[500],
    },
    titleDivider: {
        backgroundColor: tailwindPalette.slate[900],
    },
    keyFunctionContainer: {
        maxWidth: "8rem",
    },
}))

export function TerminalCheatsheet() {
    const { classes, cx } = useStyles()

    return (
        <Grid item xs={8} md={7}>
            <FormCard>
                <Stack direction="column" spacing="2rem">
                    <LocalizedStrict id="support-reports-health-adyen-summary-main-title">
                        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                            Terminal cheatsheet
                        </Typography>
                    </LocalizedStrict>
                    <Stack direction="row" spacing="1rem">
                        <img src={TerminalImage} alt="Terminal" className={classes.terminalImage} />

                        <Box display="flex" flexDirection="column" width="100%" justifyContent="space-between">
                            <Box className={classes.keyFunctionContainer}>
                                <Grid container spacing={1}>
                                    <Grid item display="flex" justifyContent="center" xs={4}>
                                        <LocalizedStrict id="support-reports-health-adyen-summary-terminal-key">
                                            <Typography variant="subtitle1" fontWeight="bold">
                                                Key
                                            </Typography>
                                        </LocalizedStrict>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <LocalizedStrict id="support-reports-health-adyen-summary-terminal-function">
                                            <Typography variant="subtitle1" fontWeight="bold">
                                                Function
                                            </Typography>
                                        </LocalizedStrict>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider className={classes.titleDivider} />
                                    </Grid>
                                    <Grid item display="flex" justifyContent="center" xs={4}>
                                        <FontAwesomeIcon
                                            icon={faXmark}
                                            className={cx(classes.keyIcon, classes.cancelKey)}
                                        />
                                    </Grid>
                                    <Grid item xs={8}>
                                        <LocalizedStrict id="support-reports-health-adyen-summary-terminal-key-cancel">
                                            <Typography variant="body1">Cancel</Typography>
                                        </LocalizedStrict>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>
                                    <Grid item display="flex" justifyContent="center" xs={4}>
                                        <FontAwesomeIcon
                                            icon={faChevronLeft}
                                            className={cx(classes.keyIcon, classes.clearKey)}
                                        />
                                    </Grid>
                                    <Grid item xs={8}>
                                        <LocalizedStrict id="support-reports-health-adyen-summary-terminal-key-clear">
                                            <Typography variant="body1">Clear</Typography>
                                        </LocalizedStrict>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider />
                                    </Grid>
                                    <Grid item display="flex" justifyContent="center" xs={4}>
                                        <FontAwesomeIcon
                                            icon={faCircle}
                                            className={cx(classes.keyIcon, classes.confirmKey)}
                                        />
                                    </Grid>
                                    <Grid item xs={8}>
                                        <LocalizedStrict id="support-reports-health-adyen-summary-terminal-key-confirm">
                                            <Typography variant="body1">Confirm</Typography>
                                        </LocalizedStrict>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider sx={{ marginBottom: 2 }} />
                                    </Grid>
                                </Grid>
                            </Box>

                            <Grid container spacing={1}>
                                <Grid item xs={4}>
                                    <Typography variant="body1">
                                        <LocalizedStrict id="support-reports-health-adyen-summary-terminal-press-1">
                                            <span> Press 1 +</span>
                                        </LocalizedStrict>
                                        <FontAwesomeIcon
                                            icon={faCircle}
                                            className={cx(classes.smallKeyIcon, classes.confirmKey)}
                                        />
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <LocalizedStrict id="support-reports-health-adyen-summary-terminal-function-custom-menu">
                                        <Typography variant="body1">Custom menu</Typography>
                                    </LocalizedStrict>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body1">
                                        <LocalizedStrict id="support-reports-health-adyen-summary-terminal-press-5">
                                            <span> Press 5 +</span>
                                        </LocalizedStrict>
                                        <FontAwesomeIcon
                                            icon={faCircle}
                                            className={cx(classes.smallKeyIcon, classes.confirmKey)}
                                        />
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <LocalizedStrict id="support-reports-health-adyen-summary-terminal-function-informational-menu">
                                        <Typography variant="body1">Informational menu</Typography>
                                    </LocalizedStrict>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body1">
                                        <LocalizedStrict id="support-reports-health-adyen-summary-terminal-press-8">
                                            <span> Press 8 +</span>
                                        </LocalizedStrict>
                                        <FontAwesomeIcon
                                            icon={faCircle}
                                            className={cx(classes.smallKeyIcon, classes.confirmKey)}
                                        />
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <LocalizedStrict id="support-reports-health-adyen-summary-terminal-function-payments-menu">
                                        <Typography variant="body1">Payments menu</Typography>
                                    </LocalizedStrict>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body1">
                                        <LocalizedStrict id="support-reports-health-adyen-summary-terminal-press-9">
                                            <span> Press 9 +</span>
                                        </LocalizedStrict>
                                        <FontAwesomeIcon
                                            icon={faCircle}
                                            className={cx(classes.smallKeyIcon, classes.confirmKey)}
                                        />
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <LocalizedStrict id="support-reports-health-adyen-summary-terminal-function-admin-menu">
                                        <Typography variant="body1">Admin menu</Typography>
                                    </LocalizedStrict>
                                </Grid>
                            </Grid>
                        </Box>
                    </Stack>
                </Stack>
            </FormCard>
        </Grid>
    )
}
